import { Route, Routes } from 'react-router-dom';

import RouteWithTitle from '../../../../src/routes/RouteWithTitle';
import { useWorkspaceContext } from '../../../context';
import CustomizeClientFields from '../../clientsSettings/components/CustomizeClientFields';
import CustomizeClosureField from '../../closures/components/CustomizeClosureField';
import Invoices from '../components/Invoices';
import MyPlan from '../components/MyPlan';
import RazorPayInvoicePdf from '../components/RazorPayInvoicePdf';
import RechargeInvoicePDF from '../components/RechargeInvoicePDF';
import SettingsOptions from '../settingsOptions/SettingsOptions';

export const AppSettingsRoutes = () => {
  const workspaceContext = useWorkspaceContext();
  const owns = workspaceContext.owns;

  return (
    <Routes>
      <Route
        path="/"
        element={
          <RouteWithTitle title="Application Settings- Wisestep">
            <SettingsOptions />
          </RouteWithTitle>
        }
      />
      <Route
        path="/teams-and-users"
        element={
          <RouteWithTitle title="Teams and User Settings- Wisestep">
            <SettingsOptions />
          </RouteWithTitle>
        }
      />
      <Route
        path="/jobs"
        element={
          <RouteWithTitle title="Job Settings- Wisestep">
            <SettingsOptions />
          </RouteWithTitle>
        }
      />
      <Route
        path="/analytics"
        element={
          <RouteWithTitle title="Analytics Settings- Wisestep">
            <SettingsOptions />
          </RouteWithTitle>
        }
      />
      <Route
        path="/crm"
        element={
          <RouteWithTitle title="CRM Settings- Wisestep">
            <SettingsOptions />
          </RouteWithTitle>
        }
      />
      <Route
        path="/account"
        element={
          <RouteWithTitle title="Account Settings- Wisestep">
            <SettingsOptions />
          </RouteWithTitle>
        }
      />
      <Route
        path="/data-privacy"
        element={
          <RouteWithTitle title="Data Privacy Settings- Wisestep">
            <SettingsOptions />
          </RouteWithTitle>
        }
      />
      <Route
        path="/apps-and-integrations"
        element={
          <RouteWithTitle title="Apps and Integration- Wisestep">
            <SettingsOptions />
          </RouteWithTitle>
        }
      />
      <Route
        path="/career-pages"
        element={
          <RouteWithTitle title="Career Page Settings- Wisestep">
            <SettingsOptions />
          </RouteWithTitle>
        }
      />
      <Route
        path="/invoice-module"
        element={
          <RouteWithTitle title="Invoice Module- Wisestep">
            <SettingsOptions />
          </RouteWithTitle>
        }
      />
      <Route
        path="/clients"
        element={
          <RouteWithTitle title="Clients- Wisestep">
            <SettingsOptions />
          </RouteWithTitle>
        }
      />
      <Route
        path="/leads"
        element={
          <RouteWithTitle title="Leads- Wisestep">
            <SettingsOptions />
          </RouteWithTitle>
        }
      />
      <Route
        path="/help-and-knowledge"
        element={
          <RouteWithTitle title="Help and Knowledge- Wisestep">
            <SettingsOptions />
          </RouteWithTitle>
        }
      />
      <Route
        path="/plan-details"
        element={<RouteWithTitle title="My Plan">{owns ? <MyPlan /> : <></>}</RouteWithTitle>}
      />
      <Route
        path="/customize-client-fields"
        element={
          <RouteWithTitle title="Customize Client Fields - Wisestep">
            <CustomizeClientFields />
          </RouteWithTitle>
        }
      />
      <Route
        path="/my-invoices"
        element={<RouteWithTitle title="My Invoices">{owns ? <Invoices /> : <></>}</RouteWithTitle>}
      />
      <Route
        path="/my-invoices/:id"
        element={<RouteWithTitle title="My Invoice-pdf">{<RazorPayInvoicePdf />}</RouteWithTitle>}
      />
      <Route
        path="/recharge/my-invoices/:id"
        element={
          <RouteWithTitle title="My Invoice-pdf">
            <RechargeInvoicePDF />
          </RouteWithTitle>
        }
      />
      <Route
        path="/placements"
        element={
          <RouteWithTitle title="Placements- Wisestep">
            <SettingsOptions />
          </RouteWithTitle>
        }
      />
      <Route
        path="/faqs"
        element={
          <RouteWithTitle title="FAQs - Wisestep">
            <SettingsOptions />
          </RouteWithTitle>
        }
      />
      <Route
        path="/workspace-settings"
        element={
          <RouteWithTitle title="Workspace Settings">
            <SettingsOptions />
          </RouteWithTitle>
        }
      />
      <Route
        path="/customize-placement-fields"
        element={
          <RouteWithTitle title="Customize Placement Fields - Wisestep">
            <CustomizeClosureField />
          </RouteWithTitle>
        }
      />
    </Routes>
  );
};
